import '../styles/Hero.css';
import { Link } from 'react-router-dom';

function Hero({breadcrumb, banner, title, subtitle, items, noItems}) {

  return (
    <>
      <div className='banner-hero'>
        <img src={banner} alt={title} />
        <div className='entry-header'>
          {breadcrumb && breadcrumb.length ? (
            <div className='breadcrumb'>
              <ul>
                {breadcrumb.map((item, index) => (
                  item.link ? (
                    <li><Link to={item.link}>{item.title}</Link></li>
                  ) : <li>{item.title}</li>
                  ))}
              </ul>
            </div>
          ) : ''}
          <h1>{title}</h1>
        </div>
        <div className='entry-content'>
          <h2>{subtitle} <br/> en cours chez AbbVie :</h2>
          <div className='items'>
          {items && items.length ? (
            items.map((item, index) => (
              <Link to={item.link} target="_blank" className='external-link'>
                <span className='itemTitle'>{item.title}</span>
                <span className='itemSubtitle'>{item.subtitle}</span>
              </Link>
            ))
          ) :
            <p className='no-items'>{noItems}</p>
          }
          </div>
        </div>
      </div>
    </>
  )
}

export default Hero